import { i18n } from 'next-i18next'

import ExpressionInternational from './ExpressionInternational'
import ExpressionNorwegian from './ExpressionNorwegian'

export default function Expression({
  multiplier,
  multiplicand,
  maxAnswerLen,
}: {
  multiplier: string
  multiplicand: string
  maxAnswerLen: number
}): React.ReactElement {
  if (i18n.language === 'no') {
    return <ExpressionNorwegian maxAnswerLen={maxAnswerLen} multiplicand={multiplicand} multiplier={multiplier} />
  } else {
    return <ExpressionInternational multiplicand={multiplicand} multiplier={multiplier} />
  }
}
